import { Button, Card, CardBody, Col, Container, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap";
import DataTable, { TableColumn } from "react-data-table-component";
// import CollapseFilterData from './CollapseFilterData';
import { useEffect, useMemo, useState } from "react";
import * as XLSX from 'xlsx';
import { SearchTableButton } from "../../../../utils/Constant";
import api from "../../../../utils/api";
import { AllClothAssignTableDataColumnType } from "../../../../Types/Application/Ecommerce/Ecommerce";
import Swal from "sweetalert2";
import { AllClothAssignTableAction, AllClothAssignTableStatus, AllLockerAssignTableProductName } from "../../../../Data/Application/Ecommerce/AllClothAssign";
import AllClothAssignFilterHeader from "../../../../Componant/Application/Ecommerce/ProductList/AllClothAssignFilterHeader";
import { SVG } from "../../../../AbstractElements";
import { useNavigate } from "react-router-dom";

const AllClothAssignContainer = () => {
  const navigate = useNavigate();
  const [filterText, setFilterText] = useState("");
  const [clothAssignTableDatas, setClothAssignTableDatas] = useState([]);
  const [transactionModalOpen, setTransactionModalOpen] = useState(false);
  const [transactionData, setTransactionData] = useState<any>(null);

  // Pagination-related states
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

   // Get user data
  const userData = (() => {
    try { return JSON.parse(localStorage.getItem("user") || '{}'); } catch { return {}; }
  })();
  const role = userData.role;

  const fetchAllClothAssigns = async (page: number, size: number, startDate?: string, endDate?: string) => {
    try {
      setLoading(true);
      let response;
      if (role === "Admin") {
        if (startDate) {
          // Use filtered API when dates are provided
          response = await api.get(
            `/api/ClothCalculation/GetAssignClothCalculationFilterPagination?startDate=${startDate}&endDate=${endDate}&pageNumber=${page}&pageSize=${size}`
          );
        } else {
          // Use default API
          response = await api.get(
            `/api/ClothCalculation/GetAssignClothCalculationPagination?pageNumber=${page}&pageSize=${size}`
          );
        }
        if (response.status === 200) {
          setClothAssignTableDatas(
            response.data.items.map(
              (item: any): AllClothAssignTableDataColumnType => ({
                clothCalculationId: item.clothCalculationId,
                serialNumber: item.serialNumber ?? '',
                subTotalAmount: item.subTotalAmount,
                gst: item.gst,
                grandTotalAmount: item.grandTotalAmount,
                isLocked: item.isLocked === true ? "Active" : "Inactive",
                ticketRFIdRef: item.ticketRFIdRef,
                selectedCardID: item.selectedCardID,
                totalCloth: item.totalCloth,
                refundAmount: item.refundableMoney || 0,
                payableAmount: item.payableAmount || 0,
                clothAssignDate: item.clothAssignDate,
                customerName: item.customerName ?? "",
                customerMobileNumber: item.customerMobileNumber ?? ""
              })
            )
          );

          // Set total record count from backend
          setTotalRows(response.data.totalCount);
        }
      } else {
        // Use default API for non-Admin users
        response = await api.get(
          `/api/ClothCalculation/GetAssignClothCalculationPagination?pageNumber=${page}&pageSize=${size}`
        );
        if (response.status === 200) {
          setClothAssignTableDatas(
            response.data.items.map(
              (item: any): AllClothAssignTableDataColumnType => ({
                clothCalculationId: item.clothCalculationId,
                serialNumber: item.serialNumber ?? '',
                subTotalAmount: item.subTotalAmount,
                gst: item.gst,
                grandTotalAmount: item.grandTotalAmount,
                isLocked: item.isLocked === true ? "Active" : "Inactive",
                ticketRFIdRef: item.ticketRFIdRef,
                selectedCardID: item.selectedCardID,
                totalCloth: item.totalCloth,
                refundAmount: item.refundableMoney || 0,
                payableAmount: item.payableAmount || 0,
                clothAssignDate: item.clothAssignDate,
                customerName: item.customerName ?? "",
                customerMobileNumber: item.customerMobileNumber ?? ""
              })
            )
          );

          // Set total record count from backend
          setTotalRows(response.data.totalCount);
        }
      }
      
    } catch (error) {
      console.error("Failed to fetch cloth assign:");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (startDate) {
      fetchAllClothAssigns(currentPage, pageSize, startDate, endDate);
    } else {
      fetchAllClothAssigns(currentPage, pageSize);
    }
  }, [currentPage, pageSize, startDate, endDate]);

  const handleDateSearch = () => {
    if (startDate) {
      setCurrentPage(1);
      fetchAllClothAssigns(1, pageSize, startDate, endDate);
    } else {
      // If no dates selected, fetch all data
      setCurrentPage(1);
      fetchAllClothAssigns(1, pageSize);
    }
  };

  const handleDelete = async (id: number) => {
    try {
      await api.put(`/api/ClothCalculation/ReturnRFIDCard?clothCalculationId=${id}`);
      Swal.fire('Return!', '  Cloth has been return submitted.', 'success');

      // Refresh current page data
      await fetchAllClothAssigns(currentPage, pageSize);
    } catch (error) {
      Swal.fire('Error!', 'Failed to submit return the record.', 'error');
      console.error("Return error:", error);
    }
  };

  const handleViewTransaction = async (clothCalculationId: any) => {
    try {
      const response = await api.get(
        `/api/ClothCalculation/ClothCalculationById?clothCalculationId=${clothCalculationId}`
      );
      if (response.status === 200) {
        setTransactionData(response.data);
        setTransactionModalOpen(true);
      } else {
        Swal.fire("Error!", "Failed to fetch cloth details.", "error");
      }
    } catch (error) {
      Swal.fire("Error!", "Failed to fetch cloth details.", "error");
      // console.error("Cloth details fetch error:", error);
    }
  };

  const allClothAssignTableDataColumn: TableColumn<AllClothAssignTableDataColumnType>[] = [
     {
      name: "S. No.",
      cell: (row) => <AllLockerAssignTableProductName title={row.serialNumber} />,
      sortable: true,
      grow: 4,
      minWidth: "50px",
    },
    {
      name: "Ticket Number",
      cell: (row) => <AllLockerAssignTableProductName title={row.ticketRFIdRef} />,
      sortable: true,
      grow: 4,
      minWidth: "150px",
    },
    // {
    //   name: "RFID Card No.",
    //   selector: (row) => `${row.selectedCardID}`,
    //   sortable: true,
    //   grow: 4,
    //   minWidth: "150px",
    // },
     {
      name: "Name",
      selector: (row) => `${row.customerName}`,
      sortable: true,
      grow: 6,
      minWidth: '150px',
    },
    {
      name: "Mobile No.",
      selector: (row) => `${row.customerMobileNumber ?? ""}`,
      sortable: true,
      grow: 6,
      minWidth: '150px',
    },
    {
      name: "Total Cloth Qnty.",
      selector: (row) => `${row.totalCloth}`,
      sortable: true,
      grow: 4,
      minWidth: "150px",
    },
    {
      name: "Total Amount",
      selector: (row) => `${row.subTotalAmount}`,
      sortable: true,
      grow: 4,
      minWidth: "150px",
    },
    {
      name: "Refund Amt",
      selector: (row) => `${row.refundAmount}`,
      sortable: true,
      minWidth: "150px",
    },
    {
      name: "GST",
      selector: (row) => `${row.gst}`,
      sortable: true,
      grow: 4,
      minWidth: "150px",
    },
    {
      name: "Grand Total Amt",
      selector: (row) => `${row.grandTotalAmount}`,
      sortable: true,
      minWidth: "160px",
    },
    {
      name: "Status",
      cell: (row) => <AllClothAssignTableStatus title={row.isLocked} />,
    },
    {
      name: "Assign Date",
      cell: (row) => <AllClothAssignTableStatus title={new Date(row.clothAssignDate).toLocaleDateString()} />,
    },
    {
      name: "Action",
      cell: (row) => (
        <>
          <span
            className="cursor-pointer bg-danger text-white p-2 rounded"
            title="Print Invoice"
            style={{ marginRight: 4, cursor: "pointer" }}
            onClick={() => {
              navigate(`/print-cloth-invoice/${row.clothCalculationId}`);
            }}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 24 24">
              <path d="M19 8V6a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v2H3v8h4v4h10v-4h4V8h-2zm-2 10H7v-4h10v4zm2-6a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-2-4H7V6h10v2z" />
            </svg>
          </span>
          <span
            onClick={() => handleViewTransaction(row.clothCalculationId)}
            title="View Cloth Details"
            style={{ cursor: "pointer", marginLeft: "8px" }}
            className="m-2"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zm0 13c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" />
            </svg>
          </span>
          <AllClothAssignTableAction clothCalculationId={row.clothCalculationId} onDelete={handleDelete} />
        </>
      ),
      grow: 6,
    },
  ];

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  const handlePerRowsChange = (newPerPage: number, page: number) => {
    setPageSize(newPerPage);
    setCurrentPage(page);
  };

 const filteredItems = clothAssignTableDatas.filter((item: any) => {
    if (!filterText) return true;
    const search = filterText.toLowerCase();
    return Object.values(item).some((value) =>
        value?.toString().toLowerCase().includes(search)
    );
});

  const exportToExcel = () => {
    const rowsToExport = filteredItems.map((item: any) => ({
      "S. No.": item.serialNumber,
      "Ticket Number": item.ticketRFIdRef,
      "Name": item.customerName,
      "Mobile No.": item.customerMobileNumber ?? "",
      "Total Cloth Qnty.": item.totalCloth,
      "Total Amount": item.subTotalAmount,
      "Refund Amt": item.refundAmount,
      "GST": item.gst,
      "Grand Total Amt": item.grandTotalAmount,
      "Status": item.isLocked ? "Locked" : "Unlocked",
      "Assign Date": item.clothAssignDate
        ? new Date(item.clothAssignDate).toLocaleDateString()
        : "",
    }));

    const worksheet = XLSX.utils.json_to_sheet(rowsToExport);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'ClothAssign');
    XLSX.writeFile(workbook, 'ClothAssign.xlsx');
  };

  const subHeaderComponentMemo = useMemo(() => (
    <div>
      {/* Date Filter Section */}
      <div className="d-flex align-items-center gap-3 mb-3">
        <div className="d-flex align-items-center">
          <Label className="me-2">Start Date:</Label>
          <Input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            style={{ width: '150px' }}
          />
        </div>
        <div className="d-flex align-items-center">
          <Label className="me-2">End Date:</Label>
          <Input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            style={{ width: '150px' }}
          />
        </div>
        <Button color="primary" size="sm" onClick={handleDateSearch}>
          Search
        </Button>
      { userData.role === "Admin" && (
        <Button color="success" size="sm" onClick={exportToExcel}>
          Download Excel
        </Button>
      )}
      </div>
      <div className="dataTables_filter">
        <div className="d-flex align-items-center">
          <Label className="me-2">{SearchTableButton}:</Label>
          <Input
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              setFilterText(e.target.value);
              setCurrentPage(1);
            }}
            type="search"
            value={filterText}
            style={{ minWidth: 250 }}
          />
        </div>
      </div>
    </div>
  ), [filterText, filteredItems, startDate, endDate]);

  const totalDisplayRows = filterText ? filteredItems.length : totalRows;
  
  return (
    <Container fluid>
      <Row>
        <Col sm="12">
          <Card>
            <CardBody>
              <div className="list-product-header">
                <AllClothAssignFilterHeader />
                {/* <CollapseFilterData /> */}
              </div>
              <div className="list-product">
                <div className="table-responsive">
                  <DataTable
                    data={filteredItems}
                    columns={allClothAssignTableDataColumn}
                    striped
                    highlightOnHover
                    pagination
                    paginationServer
                    paginationTotalRows={totalDisplayRows}
                    onChangePage={handlePageChange}
                    onChangeRowsPerPage={handlePerRowsChange}
                    paginationDefaultPage={currentPage}
                    paginationPerPage={pageSize}
                    paginationRowsPerPageOptions={[10, 15, 20, 25, 30, 50, 100]}
                    progressPending={loading}
                    selectableRows
                    subHeader
                    subHeaderComponent={subHeaderComponentMemo}
                    noDataComponent="No records found matching your search, try remove initial zero from RFID Card No. and search again."
                  />
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
      <Modal
        isOpen={transactionModalOpen}
        toggle={() => setTransactionModalOpen(false)}
        size="xl"
        style={{
          maxWidth: "90vw",
          width: "90vw",
          minHeight: "70vh",
          top: "5vh",
        }}
        contentClassName="custom-transaction-modal"
      >
        <ModalHeader
          toggle={() => setTransactionModalOpen(false)}
          style={{
            fontSize: "2rem",
            fontWeight: 700,
            borderBottom: "2px solid #eee",
            background: "#f0f4f8",
            color: "#222",
            letterSpacing: 1,
          }}
        >
          <span style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <SVG
              iconId="credit-card"
              style={{ width: 32, height: 32, fill: "#007bff" }}
            />
            Cloth Details
          </span>
        </ModalHeader>
        <ModalBody
          style={{
            padding: "2.5rem 2rem 2rem 2rem",
            background: "#f8f9fa",
            minHeight: "60vh",
            overflowY: "auto",
          }}
        >
          {transactionData ? (
            Array.isArray(transactionData) ? (
              transactionData.length > 0 ? (
                <div className="row g-4">
                  {transactionData.map((txn: any, idx: number) => (
                    <div key={idx} className="col-md-6 col-lg-4 mb-4">
                      <div
                        style={{
                          background: "#fff",
                          borderRadius: 18,
                          boxShadow: "0 4px 24px #0002",
                          padding: 28,
                          height: "100%",
                          border: "1px solid #e3e6ea",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "space-between",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginBottom: 16,
                          }}
                        >
                          <SVG
                            iconId="file-text"
                            style={{
                              width: 22,
                              height: 22,
                              fill: "#007bff",
                              marginRight: 8,
                            }}
                          />
                          <h5
                            style={{ margin: 0, fontWeight: 700, fontSize: 18 }}
                          >
                            Quantity: {txn.clothQuantity}
                          </h5>
                        </div>
                        <div style={{ fontSize: 15, color: "#444" }}>
                          <p style={{ marginBottom: 8 }}>
                            <b>Size:</b> {txn.size}
                          </p>
                          <p style={{ marginBottom: 8 }}>
                            <b>Gender:</b> {txn.gender}
                          </p>
                          <p style={{ marginBottom: 8 }}>
                            <b>Amount:</b>{" "}
                            <span style={{ color: "#007bff", fontWeight: 600 }}>
                              ₹{txn.clothPrice}
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <p style={{ textAlign: "center", color: "#888", fontSize: 18 }}>
                  No data found.
                </p>
              )
            ) : (
              <div
                style={{
                  background: "#fff",
                  borderRadius: 18,
                  boxShadow: "0 4px 24px #0002",
                  padding: 32,
                  maxWidth: 500,
                  margin: "0 auto",
                  border: "1px solid #e3e6ea",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: 16,
                  }}
                >
                  <SVG
                    iconId="file-text"
                    style={{
                      width: 22,
                      height: 22,
                      fill: "#007bff",
                      marginRight: 8,
                    }}
                  />
                  <h5 style={{ margin: 0, fontWeight: 700, fontSize: 18 }}>
                    Quantity: {transactionData.clothQuantity}
                  </h5>
                </div>
                <div style={{ fontSize: 15, color: "#444" }}>
                  <p style={{ marginBottom: 8 }}>
                    <b>Size:</b> {transactionData.size}
                  </p>
                  <p style={{ marginBottom: 8 }}>
                    <b>Gender:</b> {transactionData.gender}
                  </p>
                  <p style={{ marginBottom: 8 }}>
                    <b>Amount:</b>{" "}
                    <span style={{ color: "#007bff", fontWeight: 600 }}>
                      ₹{transactionData.clothPrice}
                    </span>
                  </p>
                </div>
              </div>
            )
          ) : (
            <p style={{ textAlign: "center", color: "#888", fontSize: 18 }}>
              No data found.
            </p>
          )}
        </ModalBody>
        <ModalFooter
          style={{ borderTop: "2px solid #eee", background: "#f0f4f8" }}
        >
          <Button
            color="secondary"
            size="lg"
            style={{
              minWidth: 120,
              borderRadius: 8,
              fontWeight: 600,
              fontSize: 18,
            }}
            onClick={() => setTransactionModalOpen(false)}
          >
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </Container>
  );
};

export default AllClothAssignContainer;
